var _rect, _path, _g, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSushi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    rx: 32,
    fill: "url(#paint0_linear_8769_19129)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8769_19129)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8769_19129",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 66,
    height: 66
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.4918 18.5H18.5V83.5H83.4918V18.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8769_19129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0394 24.7285L82.408 59.125L69.9506 77.541L19.584 42.875L32.0394 24.7285Z",
    fill: "url(#paint1_linear_8769_19129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4086 59.125C78.0751 65.3535 63.4519 62.916 49.6412 53.166C35.561 43.6875 27.9779 30.959 32.0399 24.7285C36.3734 18.5 50.9965 20.9375 64.8073 30.6875C78.8895 39.8965 86.4705 52.8965 82.4086 59.125Z",
    fill: "url(#paint2_linear_8769_19129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9528 77.2715C65.6193 83.5 50.9962 81.0625 37.1854 71.3125C23.3747 61.5625 15.5222 49.1035 19.8536 42.6035C24.1871 36.375 38.8102 38.8125 52.621 48.5625C66.4317 58.3125 74.0148 71.041 69.9528 77.2715Z",
    fill: "url(#paint3_linear_8769_19129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4081 59.125L69.9507 77.541C65.6172 83.7695 50.9941 81.0625 37.1833 71.582C34.4746 69.6855 32.4899 67.8033 30.0527 65.6353C31.949 65.3638 33.9337 64.2695 36.3709 61.5605C40.7044 56.957 42.8701 55.873 44.7664 56.1445C46.6627 56.1445 48.8284 58.041 52.3494 62.6445C55.8705 67.248 60.7449 68.6035 63.723 66.166C63.9945 65.8945 64.2639 65.8945 64.5354 65.625C66.9726 63.7285 67.785 62.916 72.3879 54.25C73.4718 52.084 77.2623 48.5625 82.4081 50.1875C83.7614 53.709 83.7614 56.6875 82.4081 59.125Z",
    fill: "#0E0F23"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.5143 58.041C76.7238 63.457 63.4539 60.75 50.7271 51.8125C37.7266 42.875 30.1456 31.5 33.9361 26.084C37.7266 20.668 50.9965 23.375 63.7234 32.3125C76.4502 41.25 84.0333 52.625 80.5122 58.041H80.5143ZM68.5998 49.916C66.7035 52.625 60.2043 51.2695 53.7052 46.9375C47.4775 42.6035 43.6849 36.916 45.5812 34.209C47.4775 31.5 53.9766 32.8555 60.4758 37.1875C66.7035 41.5215 70.4961 47.209 68.5998 49.916Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3918 33.6516C30.3939 33.4089 30.3959 33.1764 30.7332 33.1456C31.0685 33.1147 31.3153 33.2176 31.3831 33.5611C31.6464 34.896 32.2305 36.1117 32.8228 37.315C34.2481 40.2071 36.2205 42.7166 38.378 45.0924C40.338 47.2502 42.479 49.2207 44.6633 51.146C44.8525 51.3127 45.0047 51.5225 45.2042 51.6747C45.5086 51.9071 45.4222 52.1519 45.2289 52.3617C45.0232 52.588 44.7743 52.5304 44.5584 52.3411C43.9763 51.829 43.3922 51.3188 42.8143 50.8005C40.2455 48.4884 37.7774 46.0777 35.6076 43.379C33.3658 40.5897 31.4736 37.6051 30.4885 34.1206C30.4638 34.0342 30.3939 33.7236 30.3877 33.6495L30.3918 33.6516Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4656 62.916C67.7638 63.0312 68.0065 63.1772 67.914 63.566C67.8153 63.9856 67.4924 63.8684 67.2147 63.8684C67.0522 63.8684 66.0012 63.5907 65.6331 63.4693C65.2711 63.35 65.1025 63.1299 65.2115 62.7823C65.3143 62.4573 65.5879 62.4614 65.884 62.5396C66.4064 62.6795 66.937 62.7905 67.4636 62.9139L67.4656 62.916Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9572 31.3293C30.9572 31.4383 30.953 31.5453 30.9572 31.6543C30.9674 31.9258 30.951 32.1788 30.5869 32.185C30.2455 32.1912 30.0296 31.9999 29.9823 31.6872C29.937 31.3869 29.9555 31.0742 29.974 30.7677C29.9926 30.4695 30.1777 30.307 30.4759 30.3132C30.7741 30.3193 30.9407 30.488 30.9551 30.7883C30.9633 30.9693 30.9551 31.1483 30.9572 31.3293Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1365 64.6356C71.7565 64.6809 70.5451 64.5163 69.3357 64.3188C68.9943 64.2633 68.7763 64.0885 68.7907 63.7388C68.8072 63.3521 69.1054 63.3109 69.4077 63.3418C70.1502 63.4158 70.8947 63.4961 71.6351 63.5845C72.6347 63.7038 73.6281 63.7182 74.6297 63.5722C75.0369 63.5125 75.4585 63.5537 75.874 63.5578C76.1928 63.5619 76.1722 63.7964 76.1763 64.0206C76.1825 64.4093 75.8946 64.5266 75.6169 64.5184C74.7366 64.4937 73.8708 64.7693 73.1365 64.6336V64.6356Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8769_19129",
    x1: 54.5,
    y1: 38.5,
    x2: 81.5,
    y2: 102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A3464"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8769_19129",
    x1: 41.9218,
    y1: 19.8349,
    x2: 51.9115,
    y2: 54.1382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA52A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8769_19129",
    x1: 50.106,
    y1: 17.4509,
    x2: 60.0977,
    y2: 51.7542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA52A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8769_19129",
    x1: 33.8351,
    y1: 22.1902,
    x2: 43.8247,
    y2: 56.4935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA52A0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8769_19129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white",
    transform: "translate(18.5 18.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSushi);
export default __webpack_public_path__ + "static/media/sushi.a54ec9c68df1817698f9047a5744da3b.svg";
export { ForwardRef as ReactComponent };